export function targetHasClass(event, className) {
  return event.target.className === className
}
